/**
 * Shopify native privacy banner enhancements (Fox-style):
 * - Inject corner close (X); clicking it accepts cookies (same as Confirm)
 * - Optional auto-close (theme settings → Cookie banner)
 * - Decline / Manage Preferences stay hidden via CSS
 */
(function () {
  const BANNER_ID = 'shopify-pc__banner';
  const ACCEPT_ID = 'shopify-pc__banner__btn-accept';
  const CLOSE_CLASS = 'boa-cookie-banner__close';

  let autoCloseTimer = null;

  function getCookieBannerSettings() {
    const settings =
      (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.cookieBanner) || {};
    return {
      autoCloseEnabled: !!settings.autoCloseEnabled,
      autoCloseTime: Math.max(1, parseInt(settings.autoCloseTime, 10) || 7),
      autoCloseAccept: settings.autoCloseAccept !== false,
    };
  }

  function clearAutoCloseTimer() {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
      autoCloseTimer = null;
    }
  }

  function hideBanner(banner) {
    if (!banner) {
      return;
    }
    banner.style.display = 'none';
  }

  function acceptCookies(banner) {
    clearAutoCloseTimer();

    const acceptBtn = banner.querySelector('#' + ACCEPT_ID);
    if (acceptBtn) {
      acceptBtn.click();
      return;
    }

    try {
      if (
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.setTrackingConsent === 'function'
      ) {
        Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: true,
            marketing: true,
            preferences: true,
            sale_of_data: true,
          },
          function () {}
        );
      }
    } catch (e) {
      // ignore
    }

    hideBanner(banner);
  }

  function dismissBanner(banner, accept) {
    if (accept) {
      acceptCookies(banner);
      return;
    }
    clearAutoCloseTimer();
    hideBanner(banner);
  }

  function ensureCloseButton(banner) {
    if (banner.querySelector('.' + CLOSE_CLASS)) {
      return;
    }

    const closeLabel =
      (window.FoxTheme &&
        FoxTheme.accessibilityStrings &&
        FoxTheme.accessibilityStrings.close) ||
      'Close';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = CLOSE_CLASS;
    closeBtn.setAttribute('aria-label', closeLabel);
    closeBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<line x1="18" y1="6" x2="6" y2="18"></line>' +
      '<line x1="6" y1="6" x2="18" y2="18"></line>' +
      '</svg>';

    closeBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      acceptCookies(banner);
    });

    banner.appendChild(closeBtn);
  }

  function setupAutoClose(banner) {
    const { autoCloseEnabled, autoCloseTime, autoCloseAccept } = getCookieBannerSettings();

    clearAutoCloseTimer();

    if (!autoCloseEnabled) {
      return;
    }

    autoCloseTimer = setTimeout(function () {
      dismissBanner(banner, autoCloseAccept);
    }, autoCloseTime * 1000);
  }

  function bindManualDismiss(banner) {
    if (banner.dataset.boaCookieDismissBound === 'true') {
      return;
    }
    banner.dataset.boaCookieDismissBound = 'true';

    const acceptBtn = banner.querySelector('#' + ACCEPT_ID);
    if (acceptBtn) {
      acceptBtn.addEventListener('click', clearAutoCloseTimer);
    }
  }

  function enhanceBanner(banner) {
    if (!banner || banner.dataset.boaCookieEnhanced === 'true') {
      return;
    }

    banner.dataset.boaCookieEnhanced = 'true';
    ensureCloseButton(banner);
    bindManualDismiss(banner);
    setupAutoClose(banner);
  }

  function scan() {
    const banner = document.getElementById(BANNER_ID);
    if (banner && banner.style.display !== 'none') {
      enhanceBanner(banner);
      observer.disconnect();
      return true;
    }
    return false;
  }

  // Shopify injects the banner asynchronously; disconnect once enhanced
  const observer = new MutationObserver(scan);

  function start() {
    if (!scan()) {
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
